'use client'
import React from 'react'
import PageWrapperMainSite from '../../pageWrapper'
import BreadCrumbs from '../../sections/breadcrumbs'
import SkewedCta from '../../sections/skewedCta'
import Article from '../../sections/article'

const InfoDetailsPage = ({
  intro_text,
  body,
  info_lists,
  breadcrumbs,
  get_snel_naar,
  cta,
}) => {
  const article = [...intro_text, ...body]
  const link =
    get_snel_naar && get_snel_naar.length > 0 && get_snel_naar[0].value
  const ctaData = cta?.length > 0 && cta[0].value

  return (
    <>
      <BreadCrumbs breadcrumbs={breadcrumbs} spacing={88} widthVariant="full" />

      <Article article={article} lists={info_lists} link={link} />

      {ctaData && (
        <SkewedCta
          title={ctaData.link?.text}
          text={ctaData.text}
          href={ctaData?.link?.href || ctaData?.link?.external_url}
          image={ctaData?.image}
          addShadow={false}
          padding={95}
        />
      )}
    </>
  )
}

export default InfoDetailsPage
